<script setup lang="ts">
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'

import { usePageStore } from '../../stores/page'
import { useImgSrcSet } from '../../composables/use-img-src-set'

import type { VodTeaserForEpgBroadcastParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = defineProps<{
  vodTeaserForEpgBroadcast: VodTeaserForEpgBroadcastParagraph['vodTeaserForEpgBroadcast']
}>()

const { createImgSrcSetArray } = useImgSrcSet()
const { brandFromStore } = storeToRefs(usePageStore())

const teaserGroupType = 'bx-teaser-container--vod-on-epg'
const fallbackPlaceholderSource = ref<string | undefined>()
const fallbackPlaceholderSourceWidth = ref(0)

const setMediaQuery = (viewport: string) => `(max-width: ${viewport}px)`

const imgSrcSetArray = (type: string) => {
  const srcSetArray = createImgSrcSetArray(props.vodTeaserForEpgBroadcast.poster ?? {}, brandFromStore.value, teaserGroupType, type)
  for (const { src } of srcSetArray) {
    const match = src.match(/w=([0-9]+)/g)
    const imageWidth = match ? parseInt(match[0].substring(2)) : 0
    if (imageWidth > fallbackPlaceholderSourceWidth.value) {
      fallbackPlaceholderSourceWidth.value = imageWidth
      fallbackPlaceholderSource.value = src.replace('.jpeg', '.webp')
    }
  }
  return srcSetArray
}

const imageAltText = computed(() => `${props.vodTeaserForEpgBroadcast.poster?.imageAltText ?? ''} - Foto: TMDB`)
</script>

<template>
  <div class="bx-teaser-container bx-teaser-container--full-width">
    <div class="bx-teaser-container__wrapper">
      <section class="bx-teaser bx-teaser--vod-on-epg bx-typo--teaser bx-typo--form">
        <a :href="vodTeaserForEpgBroadcast?.url"
           target="_self">
          <div class="bx-teaser__content">
            <figure class="bx-teaser__image">
              <picture v-if="vodTeaserForEpgBroadcast.poster">
                <source v-for="(singleSrc, index) in imgSrcSetArray('webp')"
                        :key="index + 'webp'"
                        type="image/webp"
                        loading="lazy"
                        :media="setMediaQuery(singleSrc.viewportWidth)"
                        :srcset="singleSrc.src">
                <img :src="fallbackPlaceholderSource"
                     data-pin-nopin="true"
                     loading="lazy"
                     width="1600"
                     height="900"
                     :alt="imageAltText"
                     :title="imageAltText">
              </picture>
            </figure>
            <div class="bx-teaser__headline">
              Mehr zu &bdquo;{{ vodTeaserForEpgBroadcast.title }}&ldquo;
            </div>
            <p class="bx-teaser__copy">
              Du willst mehr erfahren? Auf der Detailseite findest du Bilder, Besetzung, Hintergrundinfos und alle Streaming-Optionen im Überblick.
            </p>
            <div class="bx-teaser__button">
              <div class="bx-form__button">Alle Infos ansehen</div>
            </div>
          </div>
        </a>
      </section>
    </div>
  </div>
</template>
